import PropTypes from 'prop-types';

export const NormalizedSearchResultPropType = PropTypes.exact({
  guideTitle: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  index: PropTypes.oneOf(['guides', 'instructions', 'steps']).isRequired,
  instructionTitle: PropTypes.string,
  locale: PropTypes.string.isRequired,
  media: PropTypes.object,
  stepCount: PropTypes.number,
  title: PropTypes.string.isRequired,
  topicTitle: PropTypes.string,
  totalPublishedInstructionsNumber: PropTypes.number
});

/**
 * Maps an Elastic Search result entry to a normalized representation.
 *
 * @param entry - The Elastic Search result entry to normalize.
 * @returns The normalized representation.
 */
export const normalizeElasticSearchResult = entry => {
  const {_id: id, _source} = entry;
  const {guideTitle, instructionTitle, locale, media, stepCount, title, topicTitle, totalPublishedInstructionsNumber} =
    _source;
  const index = entry._index.split('_')[1]; // remove schema prefix from index

  return {
    guideTitle,
    id,
    index,
    instructionTitle,
    locale,
    media,
    stepCount,
    title,
    topicTitle,
    totalPublishedInstructionsNumber
  };
};
